import { Component } from "@angular/core";
import { DocumentsListComponent } from "./documents-list/documents-list.component";

/**
 * DocumentsComponent - wrapper dla unified documents listing
 * Cała logika przeniesiona do DocumentsListComponent
 */
@Component({
  standalone: true,
  selector: 'app-documents',
  imports: [DocumentsListComponent],
  template: `<app-documents-list></app-documents-list>`,
  styles: [`:host { display: block; width: 100%; height: 100%; }`]
})
export class DocumentsComponent {}
